<advanced-filter (onSubmit)="applyFilter()" *ngIf="isCoLogin()"></advanced-filter>
<app-spinner-overlay [showSpinner]="loading"></app-spinner-overlay>
<wl-card heading="Sanction ({{totalCount}})" subheading1="{{subheading1}}" subheading2="{{subheading2}}"
  *ngIf="showNtbDataTable">



  <wl-date-input (dateRangeSelected)="onDateRangeSelected($event)" *ngIf="!isCoLogin()"></wl-date-input>

  <span *ngIf="showSelectedDate && !isCoLogin()" class="datetext">&nbsp;&nbsp;{{selectedDate}}&nbsp;&nbsp;<img
      src="../../../assets/fontawesome-web/svgs/regular/rectangle-xmark.svg" class="h-15px"
      (click)="closeButtonClick()">
  </span>


  <wl-search-input (searchValueChanged)="onSearch($event)" [ngClass]="{'search': isCoLogin()}"></wl-search-input>
  <br>


  <p *ngIf="noUserFound" class="m-100px text-center font-size-15em">{{noUserFound}}</p>

  <div class="font-size-12px table-responsive" *ngIf="!noUserFound" child-container>
    <form [formGroup]="sanctionForm">
      <table class="table table-hover table-scrollable">
        <thead>
          <tr>
            <th class="w-0pct">Sr. No.</th>
            <th class="w-3pct">Loan Reference No.<br>
            <th class="w-5pct">Borrower Name<br>
            <th class="w-0pct">Aadhaar No.<br>
            <th class="w-7pct">Branch<br>
            <th class="w-0pct">Sanction Date<br>
            <th class="w-0pct">Loan Account <br> Open date<br>
            <th class="text-center w-22pct">Customer ID <br>
            <th class="w-7pct">Checks<br>
            <th *ngIf="showSanctionedDocuments">Download <br> Sanctioned <br> Documents</th>
            <th *ngIf="showDownloadUploadColumn">Upload/ <br> Download <br> Documents</th>
            <!-- <th class="w-0pct">Download documents<br> -->




          </tr>
        </thead>
        <tbody formArrayName="sanctionRows">
          <tr *ngFor="let user of allUsers;let i = index;" [formGroupName]="i">
            <td class="vertical-align-middle">
              <p>{{10 *(pageId-1)+i+1}}</p>
            </td>
            <td class="vertical-align-middle">
              <p>{{user.ubi_reference_no }}</p>
            </td>
            <td class="vertical-align-middle">
              <p>{{(user?.profile?.first_name) ? user.profile.first_name : ""}}</p>
            </td>
            <td class="vertical-align-middle">
              <p>{{user?.aadhar_details?.aadharNo}}</p>
            </td>
            <td class="vertical-align-middle">
              <p>{{user?.branch_name}}</p>
            </td>
            <td class="vertical-align-middle">
              <p>{{user?.loanApplicationDate | date:'d/M/yy'}}</p>
            </td>
            <td class="vertical-align-middle">
              <p>{{!user?.lde_date ? '- - - -' : user.lde_date | date:'d/M/yy'}}</p>
            </td>
            <td class="vertical-align-middle text-center">
              <div>
                <input formControlName="customerId" class="form-control mb-10px" type="text"
                  size="10" maxlength="10"
                  oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                  [readonly]="user.custId && user.kyc_date && user.lde_date || !enableViewsOnLogin" />
                <div class="w3-show-inline-block">
                  <div class="w3-bar">
                    <button class="font-size-11px mybutton"
                      [disabled]="checkUpdateCustIdDisabled(i, user) || !enableViewsOnLogin"
                      (click)="updateCustId(user,i)">Update</button>
                    <button class="font-size-11px m-3px mybutton"
                      [disabled]="!user?.kyc_date || !user?.lde_date || !user?.crop_lien_date || !enableViewsOnLogin || user?.loanAccountNumber || user?.loanAccountNo"
                      (click)="createLoan(user,i)">Create Loan Account</button>
                  </div>
                </div>
              </div>

            </td>
            <td class="vertical-align-middle checkbox-td">

              <label [ngClass]="{'label-disabled': !user?.custId || !enableViewsOnLogin}" class="flex line-height-14"> <input #o1
                  class="mr-12px" type="checkbox" [disabled]="!user?.custId || !enableViewsOnLogin || user?.kyc_date"
                  id="myCheck1" (click)="openModal2($event, user)" [checked]="user.kyc_date" /> KYC Compliance
                done</label> <br>

              <label [ngClass]="{'label-disabled': !user?.custId || !enableViewsOnLogin}" class="flex line-height-14"> <input #o2
                  class="mr-12px" type="checkbox" [disabled]="!user?.custId || !enableViewsOnLogin || user?.lde_date"
                  id="myCheck2" (click)="openModal3($event,user,i)" [checked]="user.lde_date" />Loan Documents
                Executed</label> <br>

              <label [ngClass]="{'label-disabled': !user?.custId || !enableViewsOnLogin}" class="flex line-height-14"> <input #o3
                  class="mr-12px" type="checkbox" [disabled]="!user?.custId || !enableViewsOnLogin || user?.crop_lien_date"
                  id="myCheck3" (click)="openModal6($event, user)" [checked]="user.crop_lien_date" />Bank's lien
                (hypothecation) on crop created / noted</label> <br>
            </td>
            <!-- <td (click)="getDocs(user);" class="download-docs vertical-align-middle">
              <P>Download</P>
            </td> -->
            <td (click)="getDocs(user);" class="download-docs vertical-align-middle"
              *ngIf="showSanctionedDocuments">
              <P>Download</P>
            </td>
            <td class="vertical-align-middle cursor-pointer" *ngIf="showDownloadUploadColumn">
              <p class="text-underline" (click)="uploadPopup(user)">Upload</p>

              <p class="text-underline" (click)="downloadPopup(user)">Download</p>

            </td>
          </tr>
        </tbody>

      </table>
    </form>
  </div>
  <nav class="flex-center" *ngIf="totalPage>1" aria-label="Page navigation example">
    <ul class="pagination">
      <!-- limit - 10 -->
      <li *ngIf="page>3"><a (click)="getAllUsersPage(filter,roleId,offset - 10,10,page - 1)">Previous</a></li>
      <li *ngIf="page>2"><a (click)="getAllUsersPage(filter,roleId,offset - 20,10,page - 2)">{{page - 2}}</a></li>
      <li *ngIf="page>1"><a (click)="getAllUsersPage(filter,roleId,offset - 10,10,page - 1)">{{page - 1}}</a></li>
      <li class="page-item active"><a (click)="getAllUsersPage(filter,roleId,offset,10,page)">{{page}}</a></li>
      <li *ngIf="page<totalPage"><a (click)="getAllUsersPage(filter,roleId,offset + 10,10,page + 1)">{{page + 1}}</a>
      </li>
      <li *ngIf="page+1<totalPage"><a (click)="getAllUsersPage(filter,roleId,offset + 20,10,page + 2)">{{page + 2}}</a>
      </li>
      <li *ngIf="page<totalPage"><a (click)="getAllUsersPage(filter,roleId,offset + 10,10,page + 1)">Next</a></li>
    </ul>
  </nav>
</wl-card>

<!--Moadal for UPDATE-->
<div class="modal-background" *ngIf="showCustDetailsPopup">
  <div class="modal-content p-0">
    <div class="modal-header1">
      <h4 class="modal-title" id="modal-basic-title">Customer Details as per CBS</h4>
      <button type="button" class="text-white close_icon" (click)="closeUpdateModal()"
        aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body1 text-left">
      <table>
        <tr>
          <th scope="row">Name:</th>
          <td>{{ediTModaluser?.profile?.cust_title + " " + ediTModaluser?.profile?.first_name + " "+
            ediTModaluser?.profile?.last_name}}</td>
        </tr>
        <tr>
          <th scope="row">Account No.:</th>
          <td>{{ediTModaluser?.acc_no}}</td>
        </tr>
        <tr>
          <th scope="row">Customer ID:</th>
          <td>{{ediTModaluser?.custId}}</td>
        </tr>
        <tr>
          <th scope="row">Aadhaar No:</th>
          <td>{{ediTModaluser?.aadhar_details?.aadharNo}}</td>
        </tr>
      </table>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn mybutton" id="closeModal" (click)="closeUpdateModal()">Close</button>
    </div>
  </div>
</div>
<!--Moadal for UPDATE-->

<!--Moadal for Create Loan Application-->
<div class="modal-background" *ngIf="showLoanCreatedPopup">
  <div class="modal-content p-0">
    <div class="content">
      <div class="loanmodal-body">
        <h4 class="modal-title ml-50px" id="modal-basic-title">Loan Account for Customer ID
          {{updatedUser?.custId}} is created successfully!</h4>
        <br>
        <h4 class="modal-title ml-50px" id="modal-basic-title">Loan Account No.
          {{updatedUser?.loanAccountNumber}}</h4>
        <!-- <p>{{user?.acc_no}}</p> -->
      </div>

      <div class="loanmodal-footer">
        <button class="mb-10px btn btn-primary mybutton" type="button"
          (click)="openModal5(updatedUser)">OK</button>
      </div>
    </div>
  </div>
</div>
<!--Moadal for Create Loan Application-->


<!--Moadal for KYC Compliance-->
<div class="modal-background" *ngIf="showKycConfirmPopup">
  <div class="modal-content p-0">
    <div class="modal-header1">
      <button type="button" class="close_icon" (click)=" closeConfirmModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body-confirm text-left">
      <p>Do you confirm that the KYC Compliance for this customer is done?</p>
    </div>

    <div class="modal-footer">
      <div class="w3-show-inline-block text-center">
        <div class="w3-bar">
          <button class="mybutton mr-12px" (click)="kycChange();">Yes</button>
          <button class="mybutton" (click)="closeConfirmModal()">No</button>
        </div>
      </div>
    </div>
  </div>
</div>
<!--Moadal for KYC Compliance-->


<!--Moadal for Loan Documents Executed-->
<div class="modal-background" *ngIf="showDocExecutedPopup">
  <div class="modal-content p-0">
    <div class="modal-header1">
      <button type="button" class="close_icon" (click)=" closeLoanDocExexcutedModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body-confirm text-left">
      <th>
        <p>Date of Document Execution:</p>
      </th>
      <td>
        <input *ngIf="!docModalData?.user?.loanApplicationDate; else withMinDate;" class="m-20px date"
          type="date" name="trip-start" [(ngModel)]="documentDateString" [min]="curDate" [max]="curDate | date:'y-MM-dd'">
        <ng-template #withMinDate>
          <input class="m-20px date" type="date" name="trip-start" [(ngModel)]="documentDateString"
            [min]="docModalData.user.loanApplicationDate | date:'y-MM-dd'" [max]="curDate | date:'y-MM-dd'">
        </ng-template>

      </td>
    </div>

    <div class="modal-footer">
      <div class="w3-show-inline-block text-center">
        <div class="w3-bar">
          <button class="mybutton" (click)="docChange();">Submit</button>
        </div>
      </div>
    </div>
  </div>
</div>
<!--Moadal for Loan Documents Executed-->

<div class="modal-background" *ngIf="showLienConfirmPopup">
  <div class="modal-content modal-content-confirm p-0">
    <div class="modal-header1">
      <button type="button" class="close_icon" (click)="closeLienModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body-confirm text-left">
      <p>{{ lienCheckBoxInfo }}</p>
      <p>Do you confirm this is done for this customer?</p>
    </div>

    <div class="modal-footer">
      <div class="w3-show-inline-block text-center">
        <div class="w3-bar">
          <button class="mybutton mr-12px" (click)="lienChange();">Yes</button>
          <button class="mybutton" (click)="closeLienModal()">No</button>
        </div>
      </div>
    </div>
  </div>
</div>



<div class="modal-background" *ngIf="showDownloadDocsModal">
  <!-- <ng-template #downloadModal let-modal> -->
  <div class="modal-content p-0">
    <div class="modal-header1">

      <h4 class="modal-title" id="modal-basic-title">Download Documents</h4>
      <button type="button" class="close_icon" (click)="closeDownloadDocModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body-confirm text-left">
      <h4>Please select the documents to be downloaded:</h4>
      <ng-container *ngFor="let form of downloadForms; let idx = index;">
        <input type="checkbox" [id]="'myCheck1'+idx" [(ngModel)]="form.isChecked" />
        <label>{{form.label | titlecase}}</label> <br>
      </ng-container>
      <input type="checkbox" id="uniqueCheckboxDisbursed" (change)="changeAccWiseBre($event)" #checkRef
        *ngIf="showAccwiseBreCheckBox" /> <label *ngIf="showAccwiseBreCheckBox">Account
        wise BRE check</label><br>
      <input type="checkbox" [id]="'myCheck2'+idx" (change)="selectAllDownloadForms($event)" />
      <label>All</label> <br>
    </div>

    <div class="modal-footer">
      <div class="w3-show-inline-block text-center">
        <div class="w3-bar">
          <button class="mybutton" (click)="downloadMyForms()">Download</button>
        </div>
      </div>
    </div>
  </div>
  <!-- </ng-template> -->

</div>

<!--Moadal for Download Doc-->

<!--FinalModal-->
<div class="modal-background" *ngIf="showFinalPopup">
  <div class="modal-content p-0">
    <div class="content">
      <div class="loanmodal-body">
        <h4 class="modal-title" id="modal-basic-title">The Customer has been moved to Disbursed Page!</h4>
      </div>
    </div>
  </div>
</div>
<!--FinalModal-->

<div class="modal-background" *ngIf="showModal">
  <div class="modal-content">
    <wl-file-drag-upload (filesUploaded)="handleFilesUploaded($event)" (close)="handleClose()"
      [applicantId]="currentUser.id">Upload</wl-file-drag-upload>
  </div>
</div>

<div class="modal-background" *ngIf="showDownloadModal">
  <div class="modal-content">
    <wl-file-download-modal [applicantId]="currentUser.id"
      (close)="handleCloseDownload()">Download</wl-file-download-modal>
  </div>
</div>

<link rel="stylesheet" href="https://pro.fontawesome.com/releases/v5.10.0/css/all.css"
  integrity="sha384-AYmEC3Yw5cVb3ZcuHtOA93w35dYTsvhLPVnYs9eStHfGJvOvKxVfELGroGkvsg+p" crossorigin="anonymous" />